import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import useGetCategoryByArticleId from '../../hooks/useGetCategoryByArticleId';
import { useAppSelector } from '../../redux/hooks';
import {
  selectActiveVersion,
  selectContextVersion,
} from '../../redux/store/content/slice';
import CustomCard from '../cards/CustomCard';
import { compareTextsPartly } from '../../shared/custom-compare-lib/customCompare';
import './CompareVersions.scss';
import { getVersionName } from '../../shared/utils';

function ComparerContent() {
  const { t: translation } = useTranslation();
  const contextVersion = useAppSelector(selectContextVersion);
  const activeVersion = useAppSelector(selectActiveVersion);

  const category = useGetCategoryByArticleId(activeVersion.articleId);

  return (
    <CustomCard
      focusableHeadline
      headlineAsH1
      iconClass={category?.categoryTypeIconClass || undefined}
      iconColorHexCode={category?.categoryTypeColorHexCode || 'text-dark'}
      title={translation('compareVersions', {
        oldVersion: getVersionName(
          contextVersion.name || '',
          translation('versionFrom'),
          contextVersion.validFrom || '',
        ),
        newVersion: getVersionName(
          activeVersion.name || '',
          translation('versionFrom'),
          activeVersion.validFrom || '',
        ),
      })}>
      <div className='compare-content'>
        {parse(
          compareTextsPartly(
            `<h2 class="fs-5 mb-3">${contextVersion.title}</h2>`,
            `<h2 class="fs-5 mb-3">${activeVersion.title}</h2>`,
            true,
            true,
            true,
            true,
          ),
        )}
        {parse(
          compareTextsPartly(
            contextVersion.htmlContent,
            activeVersion.htmlContent,
            true,
            true,
            true,
            true,
          ),
        )}
      </div>
    </CustomCard>
  );
}

export default ComparerContent;
